<style lang="stylus">
    .ft-ganttmore
        floatTool_dropbox()
        .ft-expand
            background $ft-bgcolor
            border-radius $ft-boxradius
            padding 6px
            .ft-expand-item
                padding 6px 16px
                cursor pointer
                border-radius $ft-boxradius
                &:not(.active):hover
                    background $ft-hover
                &.active
                    background $ft-active

    // 悬浮窗口DOM置顶，组件内样式需要前置
    .ft-navbox
        background $ft-bgcolor
        border-bottom-left-radius $ft-boxradius
        border-bottom-right-radius $ft-boxradius
        padding 6px
        .ft-navitem
            padding 6px 16px
            width 120px
            cursor pointer
            border-radius $ft-boxradius
            &:not(.active):hover
                background $ft-hover
            &.active
                background $ft-active
</style>

<template>
    <div class="ft-ganttmore" @mousedown.stop>
        <FTSubMenu
            ref="navIcon"
            :imgIcon="'gantt-navigation'"
            :text="$t('navigation')"
            :isExpand="true"
            :lockbox="true"
            :lockboxTitle="$t('navigation')"
        >
            <template #lockboxContent>
                <div class="ft-navbox" @mousedown.stop @click.stop>
                    <div @click="setMoreGantt('navPre')" class="ft-navitem">
                        <p>{{ $t("navPre") }}</p>
                    </div>
                    <div @click="setMoreGantt('navNext')" class="ft-navitem">
                        <p>{{ $t("navNext") }}</p>
                    </div>
                    <div @click="setMoreGantt('navToStart')" v-show="!isNull" class="ft-navitem">
                        <p>{{ $t("navToStart") }}</p>
                    </div>
                    <div @click="setMoreGantt('navToEnd')" v-show="!isNull" class="ft-navitem">
                        <p>{{ $t("navToEnd") }}</p>
                    </div>
                    <div @click="setMoreGantt('showRedline')" class="ft-navitem">
                        <p>{{ isShowTodayLine ? $t("hideRedline") : $t("showRedline") }}</p>
                    </div>
                </div>
            </template>
        </FTSubMenu>
        <FtMenu :imgIcon="'float-import'" :text="$t('import')" @clickMenu="setMoreGantt('import')" />
        <input style="display: none" accept=".xlsx,.csv,.txt" ref="importExcel" type="file" @change="importExcel($event)" />
        <FTSubMenu :imgIcon="'float-export'" :text="$t('export')" :isExpand="true">
            <template #content>
                <div class="ft-expand">
                    <div @click="setMoreGantt('export', { format: 'xlsx' })" class="ft-expand-item">
                        <p>{{ $t("xlsl") }}</p>
                    </div>
                    <div @click="setMoreGantt('export', { format: 'txt' })" class="ft-expand-item">
                        <p>{{ $t("txt") }}</p>
                    </div>
                    <div @click="setMoreGantt('export', { format: 'csv' })" class="ft-expand-item">
                        <p>{{ $t("csv") }}</p>
                    </div>
                </div>
            </template>
        </FTSubMenu>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import FTSubMenu from "../public/FTSubMenu.vue";
    import FtMenu from "../public/FtMenu.vue";
    enum eGanttType {
        SelectAll,
        NewTask,
        NewSubTask,
        DeleteTask,
        Indent,
        Outdent,
        HideColumn,
        LinkTasks,
        UnlinkTasks,
        Forward,
        Backward,
        GotoTask,
        GotoTaskEnd,
        AddLeftLabel,
        AddRightLabel,
        NewTaskAfter,
        MoveUpTasks,
        MoveDownTasks,
        changeRowHeight,
        NewTaskBefore,
        DeleteLeftLabel,
        DeleteRightLabel,
        InsertColumn,
        DeleteColumn,
        MoveColToForward,
        MoveColToBack,
        TodayLine,
    }

    @Component({
        components: {
            FTSubMenu,
            FtMenu,
        },
    })
    export default class GanttMore extends Vue {
        get isShowTodayLine() {
            return this.$store.state.gantt.isShowTodayLine;
        }
        get isNull() {
            return this.$store.state.gantt.isNull;
        }
        get isGantt() {
            return this.$store.state.shape.type == "Gantt";
        }
        setMoreGantt(type, data = null) {
            let view = window["_view"];
            switch (type) {
                case "navPre":
                    view.ganttOperation(eGanttType.Backward, "Previous");
                    break;
                case "navNext":
                    view.ganttOperation(eGanttType.Forward, "Next");
                    break;
                case "navToStart":
                    !this.isNull && view.ganttOperation(eGanttType.GotoTask, "Go to Start");
                    break;
                case "navToEnd":
                    !this.isNull && view.ganttOperation(eGanttType.GotoTaskEnd, "Go to Finish");
                    break;
                case "showRedline":
                    this.isGantt && view.ganttOperation(eGanttType.TodayLine, "Today line");
                    break;
                case "import":
                    (this.$refs.importExcel as HTMLInputElement).click();
                    break;
                case "export":
                    view.exportGantt(data.format);
                    break;

                default:
                    break;
            }
            this.sensors.track("editGantt", {
                Catalogues: "shortcutToolbar",
                content: type,
            });
        }
        importExcel(e) {
            let ts = this;
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = function (e) {
                let res = window["_view"].importGantt(this.result);
                (ts.$refs.importExcel as HTMLInputElement).value = "";
            };
            this.sensors.track("editGantt", {
                Catalogues: "shortcutToolbar",
                content: "import",
            });
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "navigation": "导航",
        "navPre": "向前滚动",
        "navNext": "向后滚动",
        "navToStart": "跳至开始日期",
        "navToEnd": "跳至结束日期",
        "showRedline": "显示今日红线",
        "hideRedline": "隐藏今日红线",
        "import": "导入",
        "export": "导出",
        "xlsl": "导出为XLSX",
        "txt": "导出为TXT",
        "csv": "导出为CSV"
    },
    "en": {
        "navigation": "Navigation",
        "navPre": "Previous",
        "navNext": "Next",
        "navToStart": "Go to Start",
        "navToEnd": "Go to Finish",
        "showRedline": "Show Current Date Line",
        "hideRedline": "Hide Current Date Line",
        "import": "Import",
        "export": "Export",
        "xlsl": "Export to XLSX",
        "txt": "Export to TXT",
        "csv": "Export to CSV"
    },
    "fr": {
        "navigation": "Navigation",
        "navPre": "Précédent",
        "navNext": "Suivant",
        "navToStart": "Aller au début",
        "navToEnd": "Aller au fin",
        "showRedline": "Afficher la ligne de date actuelle",
        "hideRedline": "Masquer la ligne de date actuelle",
        "import": "Importer",
        "export": "Exporter",
        "xlsl": "Exporter vers XLSX",
        "txt": "Exporter vers TXT",
        "csv": "Exporter vers CSV"
    },
    "de": {
        "navigation": "Navigation",
        "navPre": "Zurück",
        "navNext": "Weiter",
        "navToStart": "Zum Anfang",
        "navToEnd": "Zum Ende",
        "showRedline": "Aktuelle Datumszeile anzeigen",
        "hideRedline": "Aktuelle Datumszeile ausblenden",
        "import": "Importieren",
        "export": "Exportieren",
        "xlsl": "Als XLSX exportieren",
        "txt": "Als TXT exportieren",
        "csv": "Als CSV exportieren"
    },
    "jp": {
        "navigation": "ナビゲーション",
        "navPre": "前へ",
        "navNext": "次へ",
        "navToStart": "開始",
        "navToEnd": "終了",
        "showRedline": "現在の日付線を表示",
        "hideRedline": "現在の日付線を隠す",
        "import": "インポート",
        "export": "エクスポート",
        "xlsl": "XLSXにエクスポート",
        "txt": "TXTにエクスポート",
        "csv": "CSVにエクスポート"
    },
    "es": {
        "navigation": "Navegación",
        "navPre": "Anterior",
        "navNext": "Siguiente",
        "navToStart": "Ir a Iniciar",
        "navToEnd": "Ir a Finalizar",
        "showRedline": "Mostrar la Línea de Fecha Actual",
        "hideRedline": "Ocultar Línea de Fecha Actual",
        "import": "Importar",
        "export": "Exportar",
        "xlsl": "Exportar a XLSX",
        "txt": "Exportar a TXT",
        "csv": "Exportar a CSV"
    },
    "pt": {
        "navigation": "Navegação",
        "navPre": "Anterior",
        "navNext": "Seguinte",
        "navToStart": "Ir para Início",
        "navToEnd": "Ir para Fim",
        "showRedline": "Mostrar Linha de Data Atual",
        "hideRedline": "Ocultar Linha de Data Atual",
        "import": "Importar",
        "export": "Exportar",
        "xlsl": "Exportar para XLSX",
        "txt": "Exportar para TXT",
        "csv": "Exportar para CSV"
    },
    "it": {
        "navigation": "Navigazione",
        "navPre": "Precedente",
        "navNext": "Successivo",
        "navToStart": "Vai a Inizio",
        "navToEnd": "Vai a Fine",
        "showRedline": "Mostra la riga della data corrente",
        "hideRedline": "Nascondi la riga della data corrente",
        "import": "Importa",
        "export": "Esporta",
        "xlsl": "Esporta in XLSX",
        "txt": "Esporta in TXT",
        "csv": "Esporta in CSV"
    },
    "tw": {
        "navigation": "導航",
        "navPre": "嚮前滾動",
        "navNext": "嚮後滾動",
        "navToStart": "跳至開始日期",
        "navToEnd": "跳至結束日期",
        "showRedline": "顯示今日紅線",
        "hideRedline": "隱藏今日紅線",
        "import": "導入",
        "export": "導出",
        "xlsl": "導出為XLSX",
        "txt": "導出為TXT",
        "csv": "導出為CSV"
    },
    "kr": {
        "navigation": "네이게이션",
        "navPre": "이전",
        "navNext": "다음",
        "navToStart": "시작점으로 가기",
        "navToEnd": "끝점으로 가기",
        "showRedline": "오늘 날짜 표시",
        "hideRedline": "현재 날짜 표시줄 숨기기",
        "import": "가져오기",
        "export": "내보내기",
        "xlsl": "XLSX로 내보내기",
        "txt": "TXT로 내보내기",
        "csv": "CSV로 내보내기"
    }
}
</i18n>
